<template>
  <!-- 营业执照 -->
  <div class="businesslicense">
    <img :src="yingyezhizhao" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      yingyezhizhao: require("@/CommonDP/assets/enterprise/yingyezhizhao.png"),
      checked: false
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.businesslicense {
  min-width: 1920px;
  width: 100%;
  min-height: 937px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  text-align: center;
  padding-top: 80px;
}
</style>
